import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { TranslationContext } from "../contexts/TranslationContext";

const Menu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { translations, selectedLanguage, setSelectedLanguage, routes } = useContext(TranslationContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const isActive = (path) => location.pathname === path ? "current" : "";

  const menuRef = useRef(null);
  const languageRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setIsLangOpen(false);
  };

  const toggleLang = () => {
    setIsLangOpen(!isLangOpen);
    setIsOpen(false);
  };

  const changeLanguage = (language) => {
    if (selectedLanguage !== language) {
      setSelectedLanguage(language);
      localStorage.setItem("selectedLanguage", language);

      // Get the current path and update it based on language selection
      const currentPath = location.pathname;

      // Route mappings for language switch
      const routes = {
        en: {
          "/accueil": "/home",
          "/se-connecter": "/login",
          "/enregistrer": "/register",
          "/congratulation": "/success",
          "/badge-premium": "/premium-badge",
          "/cgu": "/cgu",
          "/my-email-(donations)": "/my-wallet",
          "/chatroom": "/chatroom",
          "/send-my-opinions": "/send-messages",
        },
        fr: {
          "/home": "/accueil",
          "/login": "/se-connecter",
          "/register": "/enregistrer",
          "/success": "/congratulation",
          "/subscription": "/badge-premium",
          "/cgu": "/cgu",
          "/my-wallet": "/my-email-(donations)",
          "/chatroom": "/chatroom",
          "/send-messages": "/send-my-opinions",
        },
      };

      // Determine new path
      const updatedPath = routes[language][currentPath] || currentPath;

      // Navigate to new path without page reload
      navigate(updatedPath);
    }
    setIsLangOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        languageRef.current &&
        !languageRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        setIsLangOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="menu-container">
      <div className="menu" ref={menuRef}>
        <button className="menu-button text-white" onClick={toggleDropdown}>
          MENU <span className="arrow text-white"><i className="ri-arrow-down-s-line"></i></span>
        </button>
        {isOpen && (
           <div className="dropdown-menus">
           <Link to={routes.home} className={`${isActive(routes.home) ? "active" : ""} menu-item`}>
             {translations.home}
           </Link>
     
           <Link to={routes.sendMessages} className={`${isActive(routes.sendMessages) ? "active" : ""} menu-item`}>
             {translations.sendOpinions}
           </Link>
     
           <Link to={routes.chatroom} className={`${isActive(routes.chatroom) ? "active" : ""} menu-item`}>
             {translations.chatroom}
           </Link> 
     
           <Link to={routes.subscription} className={`${isActive(routes.subscription) ? "active" : ""} menu-item`}>
             {translations.subscription}
           </Link>
         </div>
        )}
      </div>
      <div className="language-switcher d-none" ref={languageRef}>
        <button className="language-button menu-button" onClick={toggleLang}>
          <img
            src={
              selectedLanguage === "fr"
                ? "../images/fr.png"
                : "../images/en.png"
            }
            alt={selectedLanguage === "fr" ? "French" : "English"}
            className="flag-icon"
          />{" "}
          {selectedLanguage === "fr" ? "Français" : "English"} <span className="arrow text-white"><i className="ri-arrow-down-s-line"></i></span>
        </button>
        {isLangOpen && (
          <div className="dropdown-language dropdown-menus">
            <span
              className="language-option menu-item"
              onClick={() => changeLanguage("fr")}
            >
              <img src="../images/fr.png" alt="French" className="flag-icon" />{" "}
              Français
            </span>
            <span
              className="language-option menu-item"
              onClick={() => changeLanguage("en")}
            >
              <img src="../images/en.png" alt="English" className="flag-icon" />{" "}
              English
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Menu;
